import { useMemo } from "react"
import { useBaseWithSegment, useFilteredSegment } from "connected-components/dashboard/helpers"
import { useIntradayState } from "connected-components/dashboard/hooks/use-intraday-state"
import { useGraphData } from "../../hooks/use-graph-data"
import { makeSelectedFilterItems } from "./helpers"

type GraphDataForSegmentInputs = Pick<
  ReturnType<typeof useGraphData>,
  "base" | "filter" | "normalization" | "instrument" | "disabledItems" | "intradayBatchMetadata"
>

// Shared by both custom-graph chart bodies (batch-trend and performance) to keep segment/instrument/filter shaping identical.
export function useCustomGraphSegmentInputs({
  base,
  filter,
  normalization,
  instrument,
  disabledItems,
  intradayBatchMetadata,
}: GraphDataForSegmentInputs) {
  const [{ lastIntradayBatchId }] = useIntradayState()
  const intradayBatchId = intradayBatchMetadata?.id

  const baseWithSegment = useBaseWithSegment(base ?? null, filter, normalization)
  const segment = useFilteredSegment(filter, normalization)
  const instrumentWithSegment = useMemo(() => ({ ...instrument, segment }), [instrument, segment])

  const filterItems = useMemo(() => makeSelectedFilterItems(disabledItems), [disabledItems])

  return { baseWithSegment, segment, instrumentWithSegment, filterItems, intradayBatchId, lastIntradayBatchId }
}
